import { GLBData } from '@types'
import { getProxyUrl } from '.'

function buildAuthHeaders(): HeadersInit {
  return {
    'Accept-Language': 'ES',
    'Content-Type': 'application/json',
    Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
  }
}

function resolveGetUnidadBaseUrl(): string {
  return getProxyUrl('').replace(/\/+$/, '')
}

export async function getGLBData(catalogID: string | number, realCatalogID?: string) {
  // Laterales/costados nunca tienen variante Gola (" GO").
  if (
    typeof catalogID === 'string' &&
    / GO$/i.test(catalogID) &&
    /^(LA|LB|LC|CC|CB)\d+/i.test(catalogID)
  ) {
    catalogID = catalogID.replace(/ GO$/i, '')
    if (typeof realCatalogID === 'string') {
      realCatalogID = realCatalogID.replace(/ GO$/i, '')
    }
  }

  const baseUrl = resolveGetUnidadBaseUrl()

  if (typeof catalogID === 'number') {
    const url = `${baseUrl}/api/Unidades/getunidad/${catalogID}`
    const params: RequestInit = {
      method: 'GET',
      mode: 'cors',
      headers: buildAuthHeaders(),
    }
    const data = await fetch(url, params)
    if (data.status === 200) {
      const json = await data.json()
      if (json) return json as GLBData
    }
    return null
  }

  try {
    const url = `${baseUrl}/api/Unidades/getunidad`
    const body = JSON.stringify({
      codigo: catalogID,
      date: '2023-05-12',
      catalogoId: realCatalogID ?? catalogID,
    })

    const params: RequestInit = {
      body,
      method: 'POST',
      mode: 'cors',
      headers: buildAuthHeaders(),
    }
    const data = await fetch(url, params)

    if (data.status === 200) {
      const json = await data.json()
      if (json) return json as GLBData
    } else {
      // Fallback gola
      if (typeof catalogID === 'string' && / GO$/i.test(catalogID)) {
        const catalogIDNoGola = catalogID.replace(/ GO$/i, '')
        const realCatalogIDNoGola =
          typeof realCatalogID === 'string' ? realCatalogID.replace(/ GO$/i, '') : realCatalogID
        return getGLBData(catalogIDNoGola, realCatalogIDNoGola)
      }

      const errorText = await data.text()
      const isLateral = typeof catalogID === 'string' && /^(LA|LB|LC|CC|CB)\d+/.test(catalogID)
      if (isLateral && data.status === 404) {
        return null
      }

      console.error(`❌ getGLBData: Error response: ${errorText}`)
      return null
    }
  } catch (e: any) {
    console.error('Error en getGLBData:', e as Error)
    return null
  }
}
